import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './FilterRow.css';
import { Checkbox } from '../../../Checkbox';

export class FilterRow extends Component {
  renderMobile() {
    const { filter, filterDisplay, filterGroup, filterCount, onClick, checked, percentage } = this.props;

    return (
      <div className="filter-row-mobile">
        <label htmlFor={`${filterGroup}${filter}`} className="filter-row__label">
          <span className="filter-row-group__item">{this.props.children}</span>
          <span className="filter-row-group__item--main filter-row__label-text">{filterDisplay}</span>
          <span className="filter-row-group__item">{filterCount}</span>
          <span className="filter-row-group__item">{percentage}</span>
          <span className="filter-row-group__item">
            <Checkbox
              checked={checked}
              id={`${filterGroup}${filter}`}
              onChange={(e) => onClick(e, filterGroup, filter)}
            />
          </span>
        </label>
      </div>
    );
  }

  renderDesktop() {
    const { filter, filterDisplay, filterGroup, filterCount, onClick, checked, percentage } = this.props;

    return (
      <div className="filter-row-desktop">
        <span>
          <Checkbox
            checked={checked}
            id={`${filterGroup}${filter}`}
            onChange={(e) => onClick(e, filterGroup, filter)}
          />
          <label htmlFor={`${filterGroup}${filter}`} className="filter-row__label">
            <span className="filter-row__label-text">{filterDisplay}</span>
          </label>
        </span>
        <span className="filter-row-group">
          <span className="filter-row-group__item">{this.props.children}</span>
          <span className="filter-row-group__item">{filterCount}</span>
          <span className="filter-row-group__item">{percentage}</span>
        </span>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderDesktop()}
        {this.renderMobile()}
      </React.Fragment>
    );
  }
}

FilterRow.propTypes = {
  children: PropTypes.node,
  filter: PropTypes.string.isRequired,
  filterDisplay: PropTypes.string.isRequired,
  filterGroup: PropTypes.string.isRequired,
  filterCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  percentage: PropTypes.string.isRequired,
};

FilterRow.defaultProps = { children: null };
